// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-HrisManager-CredentialsFlow-styles___formContainer--b_Uhx {
  margin: 24px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

  .components-HrisManager-CredentialsFlow-styles___formContainer--b_Uhx .components-HrisManager-CredentialsFlow-styles___credentialsForm--tuGOw {
    width: 100%;
    max-width: 400px;
  }

  .components-HrisManager-CredentialsFlow-styles___formContainer--b_Uhx .components-HrisManager-CredentialsFlow-styles___credentialsInput--flXQo {
    margin-bottom: 16px;
  }

.components-HrisManager-CredentialsFlow-styles___emailPreviewContainer--_t41N{
  padding: 0 16px 24px;
}

.components-HrisManager-CredentialsFlow-styles___emailPreviewContainer--_t41N .components-HrisManager-CredentialsFlow-styles___emailPreviewBox--xzXfz{
    text-align: left;
    border: black solid;
    border-radius: 4px;
    padding: 8px;
  }`, "",{"version":3,"sources":["webpack://./components/HrisManager/CredentialsFlow/styles.pcss"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AAUrB;;EARE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;AAGF;EACE,oBAAoB;AAOtB;;AANE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;EACd","sourcesContent":[".formContainer {\n  margin: 24px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .credentialsForm {\n    width: 100%;\n    max-width: 400px;\n  }\n\n  .credentialsInput {\n    margin-bottom: 16px;\n  }\n}\n\n.emailPreviewContainer{\n  padding: 0 16px 24px;\n  .emailPreviewBox{\n    text-align: left;\n    border: black solid;\n    border-radius: 4px;\n    padding: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `components-HrisManager-CredentialsFlow-styles___formContainer--b_Uhx`,
	"credentialsForm": `components-HrisManager-CredentialsFlow-styles___credentialsForm--tuGOw`,
	"credentialsInput": `components-HrisManager-CredentialsFlow-styles___credentialsInput--flXQo`,
	"emailPreviewContainer": `components-HrisManager-CredentialsFlow-styles___emailPreviewContainer--_t41N`,
	"emailPreviewBox": `components-HrisManager-CredentialsFlow-styles___emailPreviewBox--xzXfz`
};
module.exports = ___CSS_LOADER_EXPORT___;
